module.exports = __webpack_public_path__ + "img/ln.76a942ad.jpg";